import { useAuthorizationStore } from '@/store/authorizationStore'

function getSettingsHeaderTable() {
    const settingsHeaderTable = localStorage.getItem('settings_header_table')
    return settingsHeaderTable ? JSON.parse(settingsHeaderTable) : {}
}

function getSettingsHeaderTableDefault() {
    return checkHeaderForWorkspace(getSettingsHeaderTable())
}

function checkHeaderForWorkspace(settings = {}) {
    const authorizationStore = useAuthorizationStore()

    if (settings[authorizationStore.getWorkspaceSlug]) {
        return settings
    }

    return {
        ...settings,
        [authorizationStore.getWorkspaceSlug]: {},
    }
}

function setSettingsHeaderTable(settings) {
    localStorage.setItem('settings_header_table', settings)
}

function getActiveColumnsHeader(headers, type) {
    const authorizationStore = useAuthorizationStore()

    const columnByType = getSettingsHeaderTableDefault()[authorizationStore.getWorkspaceSlug][type]

    if (columnByType) {
        return columnByType
    }

    return getDefaultColumnsHeader(headers)
}

function getDefaultColumnsHeader(headers) {
    return headers.reduce((items, item) => {
        if (!item.hasOwnProperty('activeDefault') || !!item.activeDefault) {
            items.push(item.value)
        }

        return items
    }, [])
}

function setActiveColumnsHeader(settings, type) {
    const authorizationStore = useAuthorizationStore()

    const activeHeaders = {
        ...getSettingsHeaderTableDefault(),
    }
    activeHeaders[authorizationStore.getWorkspaceSlug][type] = settings
    setSettingsHeaderTable(JSON.stringify(activeHeaders))
}

function getActiveHeadersTable(header, activeColumnHeader = []) {
    const clone = JSON.parse(JSON.stringify(header))
    if (activeColumnHeader.length) {
        return clone.filter((f) => activeColumnHeader.some((key) => key === f.value))
    }
    return header
}

function removeHeaderTableSettings() {
    localStorage.removeItem('settings_header_table')
}

function getColumnsWidth() {
    const columnsWidth = localStorage.getItem('column_width')

    return checkHeaderForWorkspace(columnsWidth ? JSON.parse(columnsWidth) : {})
}

function setColumnsWidthToStorage(allColumnsWidth) {
    localStorage.setItem('column_width', JSON.stringify(allColumnsWidth))
}

function getColumnsOrder() {
    const columnsOrder = localStorage.getItem('column_order')

    return checkHeaderForWorkspace(columnsOrder ? JSON.parse(columnsOrder) : [])
}

function setColumnsOrderToStorage(allColumnsWidth) {
    localStorage.setItem('column_order', JSON.stringify(allColumnsWidth))
}

export {
    getActiveColumnsHeader,
    getDefaultColumnsHeader,
    setActiveColumnsHeader,
    getActiveHeadersTable,
    removeHeaderTableSettings,
    getColumnsWidth,
    setColumnsWidthToStorage,
    getColumnsOrder,
    setColumnsOrderToStorage,
}
